import styled from '@emotion/styled';
import { device, typography } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  children: React.ReactNode;
  title?: string;
}

const CardContainer = styled.ul<{ useAfter: boolean }>`
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  > * {
    margin-left: 0;
    margin-bottom: 24px;
    max-width: 100%;
  }

  @media ${device.tablet} {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 1200px;

    > * {
      margin-bottom: 44px;
      width: 100%;
      max-width: calc((1 / 2) * 100% - 20px);
    }
  }

  @media ${device.desktop} {
    > * {
      margin-bottom: 44px;
      max-width: calc((1 / 3) * 100% - 20px);
    }

    ${(props) =>
      props.useAfter &&
      `:after {
      content: '';
      flex: auto;
      max-width: calc((1 / 3) * 100% - 20px);
    }`}
  }
`;

const Host = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: ${(props) => 8 * props.theme.baseline}px;
`;

const Title = styled.h2`
  ${typography.h4};

  @media ${device.tablet} {
    ${typography.h3};
  }
  margin-bottom: ${(props) => 8 * props.theme.baseline}px;
`;

export function CardWrapper({ children, title }: IProps) {
  const count = React.Children.count(children);

  return (
    <>
      {title && <Title>{title}</Title>}
      <Host>
        <CardContainer
          tabIndex={-1}
          aria-label={title}
          useAfter={count % 3 !== 0}
        >
          {children}
        </CardContainer>
      </Host>
    </>
  );
}
